/**
 * @author Tomasz Czura (9/7/16)
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import TableAction from './TableAction';
import i18next from 'i18next';

class EditAction extends Component {
  render() {
    return (
      <TableAction text={i18next.t('links.edit')} action={() => this.props.onEdit()}
        condition={this.props.condition} icon="icon-wrench"/>
    );
  }
}

EditAction.propTypes = {
  onEdit: PropTypes.func,
  condition: PropTypes.bool,
};
EditAction.defaultProps = {};

export default EditAction;
